import { createNamespacer, createReducer } from '../utils/reducers';

const initialState = {
  filters: {
    entity: '',
    needType: '',
    businessUnit: '',
    team: '',
    reportingManager: '',
  },
  filtersForMultiSelect: {
    entity: [],
    agreementTypes: [],
    businessUnits: [],
    teams: [],
    reportingManagers: [],
    saleTypes: [],
  },
  filtersExtraData: {
    journalReportType: '',
    isAgingReport: false,
  },
  arDetailedDropdownfilters: {
    type: [],
    subType: [],
  },
  defaultMultiSelectFilters: {
    entity: [],
    agreementTypes: [],
    businessUnits: [],
    teams: [],
    reportingManagers: [],
    saleTypes: [],
  },
  dashboardMultiSelectFilters: {
    entity: [],
    businessUnits: [],
    departments: [],
    salesManagers: [],
    unitManagers: [],
  },
  dashboardParentChildStatus: {
    entity: [],
    businessUnits: [],
    departments: [],
    salesManagers: [],
    unitManagers: [],
  },
};

const namespacer = createNamespacer('FILTERS');

const handlers = {
  [namespacer('GENERATE_FILTERS')]: (state, action) => {
    return {
      ...state,
      filters: action.payload,
    };
  },
  [namespacer('GENERATE_FILTERS_EXTRA_DATA')]: (state, action) => {
    return {
      ...state,
      filtersExtraData: action.payload,
    };
  },
  [namespacer('ARDETAILED_FILTERS_DATA')]: (state, action) => {
    return {
      ...state,
      arDetailedDropdownfilters: action.payload,
    };
  },
  [namespacer('GENERATE_FILTERS_FOR_MULTI_SELECT')]: (state, action) => {
    return {
      ...state,
      filtersForMultiSelect: action.payload,
    };
  },
  [namespacer('GENERATE_DASHBOARD_FILTERS')]: (state, action) => {
    return {
      ...state,
      dashboardMultiSelectFilters: action.payload,
    };
  },
  [namespacer('GENERATE_PARENT_CHILD_STATUS')]: (state, action) => {
    return {
      ...state,
      dashboardParentChildStatus: action.payload,
    };
  },
  [namespacer('GENERATE_DEFAULT_MULTI_SELECT')]: (state, action) => {
    return {
      ...state,
      defaultMultiSelectFilters: action.payload,
    };
  },
};

const reducer = createReducer(initialState, handlers, ['FILTERS']);

export default reducer;
